<template>
  <div>
    <a
      href="#"
      class="btn btn-primary float-right half-gutter-bottom"
      v-on:click.prevent="openModal"
      >Add Office</a
    >
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Name</th>
          <th>Address</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-bind:key="key" v-for="(office, key) in offices">
          <td>
            {{ office.name }}
            <span class="label label-primary" v-if="office.primary"
              >Primary Office</span
            >
          </td>
          <td>
            {{ office.address_line_one }}, {{ office.city }},
            {{ office.postcode }}
          </td>
          <td>
            <button
              class="btn btn-warning"
              v-on:click.prevent="openEditModal(key)"
            >
              Edit
            </button>
            <button
              class="btn btn-danger"
              v-on:click.prevent="removeOffice(key)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <modal :show="modals.form" :large="true" v-on:close="closeModal">
      <div slot="title">
        <h4 v-text="formModalText"></h4>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="form-horizontal">
            <inputbox
              name="office"
              label="Name"
              :required="true"
              v-model="form.name"
              :show-error="form.errors.has('name')"
              :error-message="form.errors.get('name')"
            ></inputbox>
            <address-lookup
              v-on:address="setFormAddress"
              :address="formAddress"
            ></address-lookup>
            <toggleswitch
              :labels="true"
              name="primary"
              label="Primary Office?"
              v-model="form.primary"
            ></toggleswitch>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button
          class="btn btn-danger float-left"
          v-on:click.prevent="closeModal"
        >
          Close
        </button>
        <button class="btn btn-primary" v-on:click.prevent="saveForm">
          Save Office
        </button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    offices: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      alertIsOpen: false,
      modals: {
        form: false
      },
      form: new window.Form({
        name: null,
        address_line_one: null,
        address_line_two: null,
        city: null,
        postcode: null,
        primary: false
      }),
      editingIndex: null
    };
  },

  computed: {
    formModalText() {
      if (this.editingIndex) {
        return 'Edit Office';
      }

      return 'Add Office';
    },

    formAddress() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    },

    hasPrimaryOffice() {
      let primary = false;

      this.offices.forEach(office => {
        if (office.primary) {
          primary = true;
        }
      });

      return primary;
    }
  },

  methods: {
    removeOffice(key) {
      window
        .swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!'
        })
        .then(() => {
          let office = this.offices[key];

          window.Ajax.delete(
            `/credit-hire-organisations/${this.$route.params.identifier}/offices/${office.identifier}`
          )
            .then(response => {
              window.swal(
                'Deleted!',
                'The office was deleted successfully!',
                'success'
              );
              this.offices.splice(key, 1);
            })
            .catch(err => {
              window.toastify.error(
                'Error',
                'Sorry, there was an issue deleting the office.'
              );
            })
            .catch(() => {});
        });
    },

    saveForm() {
      let method = 'post';
      let url = `/credit-hire-organisations/${this.$route.params.identifier}/offices`;

      if (this.editingIndex !== null) {
        method = 'put';
        url = `${url}/${this.offices[this.editingIndex].identifier}`;
      }

      this.form[method](url)
        .then(response => {
          if (this.editingIndex === null) {
            this.offices.push(response);
            this.closeModal();
            return;
          }

          this.offices[this.editingIndex] = response;
          this.closeModal();
        })
        .catch(error => {});
    },

    setFormAddress(value) {
      this.form.address_line_one = value.address_line_one;
      this.form.address_line_two = value.address_line_two;
      this.form.city = value.city;
      this.form.postcode = value.postcode;
    },

    openModal() {
      this.modals.form = true;
    },

    closeModal() {
      this.modals.form = false;
      this.form.reset();
    },

    openEditModal(key) {
      this.editingIndex = key;

      this.form.name = this.offices[key].name;
      this.form.address_line_one = this.offices[key].address_line_one;
      this.form.address_line_two = this.offices[key].address_line_two;
      this.form.city = this.offices[key].city;
      this.form.postcode = this.offices[key].postcode;
      this.form.primary = this.offices[key].primary;
      this.openModal();
    }
  }
};
</script>
